<template>
  <footer class="app-footer">
    <div class="app-footer__main">
      <div class="app-footer__links">
        <div class="app-footer__company-links">
          <span class="app-footer__section-title">智谷优学</span>
          <div class="app-footer__link-row app-footer__link-row--muted">
            <router-link :to="{ name: 'about' }">关于我们</router-link>
            <span class="app-footer__separator">|</span>
            <button class="app-footer__contact-button" type="button" @click="openContact">
              联系我们
            </button>
          </div>
        </div>
        <div class="app-footer__quick-links">
          <span class="app-footer__section-title">快速链接</span>
          <nav class="app-footer__link-row app-footer__link-row--muted" aria-label="底部快速链接">
            <template v-for="(item, index) in quickLinks">
              <span v-if="index" :key="`${item.name}-separator`" class="app-footer__separator">|</span>
              <router-link :key="item.name" :to="{ name: item.name }">{{ item.label }}</router-link>
            </template>
          </nav>
        </div>
      </div>
      <div class="app-footer__official-account">
        <span class="app-footer__official-account-title">官方公众号</span>
        <img
          class="app-footer__qr-code"
          src="@/assets/pages/home/images/81ed71f127f8978386b87d0d4d911c40.png"
          alt="智谷优学官方公众号二维码"
        />
        <span class="app-footer__qr-code-caption">扫码关注</span>
      </div>
    </div>
    <div class="app-footer__copyright">© 2026 智谷优学. 保留所有权利.</div>
    <contact-dialog v-model="isContactDialogOpen" />
  </footer>
</template>

<script>
import ContactDialog from '@/components/contact/ContactDialog.vue'
import primaryNavigation from '@/config/navigation'

export default {
  name: 'AppFooter',
  components: { ContactDialog },
  data() {
    return {
      quickLinks: primaryNavigation.filter(item => item.name !== 'about'),
      isContactDialogOpen: false
    }
  },
  methods: {
    openContact() {
      this.isContactDialogOpen = true
    }
  }
}
</script>

<style scoped>
.app-footer {
  width: 100%;
  color: #fff;
  font-family: SourceHanSansCN-Regular, sans-serif;
}

.app-footer__main {
  position: relative;
  width: 100%;
  aspect-ratio: 452 / 204;
  background: #3b3b3b;
}

.app-footer__links {
  position: absolute;
  top: 21.5%;
  left: 2.2%;
  display: flex;
  width: 69%;
  flex-direction: column;
}

.app-footer__company-links,
.app-footer__quick-links {
  display: flex;
  flex-direction: column;
}

.app-footer__quick-links {
  margin-top: 25px;
}

.app-footer__section-title,
.app-footer__official-account-title {
  font-family: SourceHanSansCN-Medium, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
}

.app-footer__link-row {
  display: flex;
  align-items: center;
  margin-top: 5px;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
}

.app-footer__link-row a {
  color: inherit;
  text-decoration: none;
}

.app-footer__contact-button {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: inherit;
  cursor: pointer;
}

.app-footer__link-row--muted {
  color: #bcbcbc;
}

.app-footer__separator {
  margin: 0 7px;
}

.app-footer__official-account {
  position: absolute;
  top: 8.8%;
  right: 3%;
  display: flex;
  width: 24.3%;
  align-items: center;
  flex-direction: column;
}

.app-footer__official-account-title {
  font-family: SourceHanSansCN-Bold, sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
}

.app-footer__qr-code {
  width: 100%;
  height: auto;
  margin-top: 8px;
  aspect-ratio: 1;
  object-fit: contain;
}

.app-footer__qr-code-caption {
  margin-top: 5px;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
}

.app-footer__copyright {
  display: flex;
  width: 100%;
  aspect-ratio: 452 / 48;
  align-items: center;
  justify-content: center;
  background: #292929;
  color: #9d9d9d;
  font-size: 16px;
  line-height: 20px;
  white-space: nowrap;
}

@media (max-width: 400px) {
  .app-footer__quick-links {
    margin-top: 23px;
  }

  .app-footer__section-title,
  .app-footer__link-row,
  .app-footer__qr-code-caption,
  .app-footer__copyright {
    font-size: 13px;
    line-height: 16px;
  }

  .app-footer__official-account-title {
    font-size: 15px;
    line-height: 18px;
  }

  .app-footer__qr-code {
    margin-top: 6px;
  }

  .app-footer__separator {
    margin: 0 5px;
  }
}
</style>
